module.exports = __webpack_public_path__ + "static/media/fineartImageMobile.83e61b53.jpg";